import Interceptor from "./Interceptor";

export const fetchPlans = async () => {
  try {
    const response = await Interceptor.get("/plans");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchMyPlan = async () => {
  try {
    const response = await Interceptor.get("/plans/my-plan");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const subscribeToPlan = async (planId, billingInterval = "monthly") => {
  try {
    const response = await Interceptor.post(`/plans/${planId}/subscribe`, {
      billingInterval,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
